import { render, staticRenderFns } from "./productBoxTask.vue?vue&type=template&id=0f72844b&scoped=true&"
import script from "./productBoxTask.vue?vue&type=script&lang=js&"
export * from "./productBoxTask.vue?vue&type=script&lang=js&"
import style0 from "./productBoxTask.vue?vue&type=style&index=0&id=0f72844b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72844b",
  null
  
)

export default component.exports